import { CheckIcon } from "lucide-react";
import { ISwitch } from "types/gaiaComponents/switch";
import { ICON_SIZE } from "components/common/constants";

export const Switch = (props: ISwitch) => {
    return (
        <div className="d-flex align-items-center">
            <div className="ga-switch">
                <input type="checkbox"
                       checked={props.isChecked}
                       onChange={props.onChange}
                       disabled={props.isDisabled}
                />
                <div className="ga-switch__marker top-unset">
                    <CheckIcon className="ga-switch__check-icon" size={ICON_SIZE.SMALL}
                               absoluteStrokeWidth={true}
                               strokeWidth={2} />
                    <span className="ga-switch__slider"></span>
                </div>
                <span
                    className="ga-switch__label">{props.label}</span>
            </div>
            {props.internalComponent}
        </div>
    )
}